"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Textarea = exports.InputWithCurrency = exports.InputCheckboxGroup = exports.MaskedInput = exports.CompensationTopLabel = exports.CompensationFieldHeader = exports.InputRowGroup = exports.TopLabel = exports.LabelText = exports.InputLabel = exports.Input = exports.InputController = void 0;

var _react = _interopRequireDefault(require("react"));

var _polished = require("polished");

var _reactInputMask = _interopRequireDefault(require("react-input-mask"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Typography = require("../Typography");

var _AutoFocusInput = require("./AutoFocusInput");

var _style = require("./style");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react["default"].createElement;

/**
 * We have two themes for our form inputs.
 * - light: To be used in dark backgrounds
 * - dark: To be used in light backgrounds
 */
var InputController = _styledComponents["default"].div.withConfig({
  displayName: "Input__InputController",
  componentId: "sc-1r0nohx-0"
})(["& + &{margin-top:", ";}"], function (_ref) {
  var biggerMargin = _ref.biggerMargin;
  return biggerMargin ? '38px' : '29px';
});

exports.InputController = InputController;
var Input = (0, _styledComponents["default"])(_AutoFocusInput.AutoFocusInput).withConfig({
  displayName: "Input",
  componentId: "sc-1r0nohx-1"
})(["", ""], _style.InputStyle);
exports.Input = Input;

var InputLabel = _styledComponents["default"].label.withConfig({
  displayName: "Input__InputLabel",
  componentId: "sc-1r0nohx-2"
})(["display:block;font-weight:normal;font-size:", ";line-height:1.2;> span:first-child{margin-bottom:8px;}"], (0, _polished.rem)('13px'));

exports.InputLabel = InputLabel;

var LabelText = _styledComponents["default"].span.withConfig({
  displayName: "Input__LabelText",
  componentId: "sc-1r0nohx-3"
})(["display:inline-block;color:var(--labelTextColor);", " ", ""], function (_ref2) {
  var $size = _ref2.$size;
  return $size === 'md' ? (0, _styledComponents.css)(["font-size:", ";"], (0, _polished.rem)('16px')) : null;
}, function (_ref3) {
  var theme = _ref3.theme;

  switch (theme.mode) {
    case 'light':
      return (0, _styledComponents.css)(["--labelTextColor:rgba(255,255,255,0.5);"]);

    case 'dark':
    default:
      return (0, _styledComponents.css)(["--labelTextColor:var(--colors-lynch);"]);
  }
});

exports.LabelText = LabelText;

var TopLabel = _styledComponents["default"].span.withConfig({
  displayName: "Input__TopLabel",
  componentId: "sc-1r0nohx-4"
})(["display:block;color:var(--topLabelColor);", " ", " strong{font-weight:600;}"], function (_ref4) {
  var $size = _ref4.$size;

  switch ($size) {
    case 'md':
      return (0, _styledComponents.css)(["font-size:", ";"], (0, _polished.rem)('16px'));

    default:
      return null;
  }
}, function (_ref5) {
  var theme = _ref5.theme,
      show = _ref5.show;

  switch (theme.variant) {
    case 'outline':
      return (0, _styledComponents.css)(["font-size:14px;font-weight:500;--topLabelColor:var(--colors-darkBlue);"]);

    default:
      // 'inline'
      return (0, _styledComponents.css)(["opacity:", ";transform:translateY(", ");transition:0.1s ease;transition-property:'opacity, transform';--topLabelColor:", ";"], show ? 1 : 0, show ? '0' : '10px', theme.mode === 'light' ? 'rgba(255, 255, 255, 0.7);' : 'var(--brandPrimary)');
  }
});

exports.TopLabel = TopLabel;

var InputRowGroup = _styledComponents["default"].div.withConfig({
  displayName: "Input__InputRowGroup",
  componentId: "sc-1r0nohx-5"
})(["display:flex;align-items:center;> * + *{margin-left:1rem;}"]);

exports.InputRowGroup = InputRowGroup;

var CompensationFieldHeader = _styledComponents["default"].div.withConfig({
  displayName: "Input__CompensationFieldHeader",
  componentId: "sc-1r0nohx-6"
})(["margin-bottom:16px;"]);

exports.CompensationFieldHeader = CompensationFieldHeader;

var CompensationTopLabel = _styledComponents["default"].span.withConfig({
  displayName: "Input__CompensationTopLabel",
  componentId: "sc-1r0nohx-7"
})(["display:block;font-weight:500;font-size:1rem;line-height:1.187em;margin-bottom:8px;", ""], function (_ref6) {
  var theme = _ref6.theme;

  switch (theme.mode) {
    case 'light':
      return (0, _styledComponents.css)(["--topLabelColor:rgba(255,255,255,0.6);"]);

    case 'dark':
      return (0, _styledComponents.css)(["--topLabelColor:var(--brandPrimary);"]);

    default:
      return null;
  }
});

exports.CompensationTopLabel = CompensationTopLabel;
var MaskedInput = (0, _styledComponents["default"])(_reactInputMask["default"]).attrs(function () {
  return {
    type: 'text'
  };
}).withConfig({
  displayName: "Input__MaskedInput",
  componentId: "sc-1r0nohx-8"
})(["", " ", " ", ""], _style.InputStyle, function (_ref7) {
  var $size = _ref7.$size;
  return $size === 'md' ? (0, _styledComponents.css)(["font-size:", ";"], (0, _polished.rem)('16px')) : null;
}, function (_ref8) {
  var theme = _ref8.theme,
      value = _ref8.value;
  var style;

  if (theme.mode === 'light') {
    style = (0, _styledComponents.css)(["--inputColor:var(--colors-blank);"]);
  }

  if (theme.mode === 'dark') {
    style = (0, _styledComponents.css)(["--inputColor:var(--colors-lynch);&:hover,&:focus{--inputColor:var(--colors-darkBlue);}"]);

    if ((value === null || value === void 0 ? void 0 : value.length) > 0) {
      style = (0, _styledComponents.css)(["--inputColor:var(--colors-darkBlue);"]);
    }
  }

  return style;
});
exports.MaskedInput = MaskedInput;

var InputCheckboxGroup = _styledComponents["default"].div.withConfig({
  displayName: "Input__InputCheckboxGroup",
  componentId: "sc-1r0nohx-9"
})(["", " + &{margin-top:1rem;}"], InputLabel);

exports.InputCheckboxGroup = InputCheckboxGroup;

var InputsContainer = _styledComponents["default"].div.withConfig({
  displayName: "Input__InputsContainer",
  componentId: "sc-1r0nohx-10"
})(["position:relative;"]);

var CurrencyContainer = _styledComponents["default"].span.withConfig({
  displayName: "Input__CurrencyContainer",
  componentId: "sc-1r0nohx-11"
})(["", ";position:absolute;top:0;right:0;height:100%;display:flex;align-items:center;color:var(--colors-lynch);"], _Typography.H5);

var InputWithCurrency = function InputWithCurrency(_ref9) {
  var currency = _ref9.currency,
      children = _ref9.children;
  return __jsx(InputsContainer, null, children, __jsx(CurrencyContainer, null, currency));
};

exports.InputWithCurrency = InputWithCurrency;

var Textarea = _styledComponents["default"].textarea.withConfig({
  displayName: "Input__Textarea",
  componentId: "sc-1r0nohx-12"
})(["resize:vertical;min-height:44px;height:110px;border:2px solid var(--inputBorderColor);border-radius:8px;padding:8px;"]);

exports.Textarea = Textarea;